<template>
  <b-card
    class="order-card-select"
    :title=option.name
    :img-src=option.image_path
    :img-alt=option.name
    img-bottom
    @click="emitCardChoice(option.id)"
    >
  </b-card>
</template>

<script>
export default {
  name: 'ChooseCard',
  props: ['option'],
  data () {
    return {
    }
  },
  methods: {
    emitCardChoice(selection) {
      this.$emit('emit-card-choice', selection);
    }
  },
}
</script>

<style>

</style>
